















































































import {Component, PropSync} from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import {SelectWings, ToggleWings, InputWings} from 'wings-ui-components';
import { ManagementTemplatesFilter } from '@/store/mail_notify/management_templates/types';
import BaseFilter from "@/components/Filter/BaseFilter";
import { MsgTransports } from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, ToggleWings, InputWings}})
export default class MNManagementTemplatesFilter extends BaseFilter<ManagementTemplatesFilter> {

  @PropSync("show") is_show!: boolean;

  @Action("getManagementTemplates") actionGetManagementTemplates: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getManagementServices") actionGetManagementServices: any;

  @Getter("managementTemplatesStatus") managementTemplatesStatus: any;
  @Getter("managementServices") managementServicesList: any;

  params = {transport: MsgTransports.MAILNOTIFY};
  serviceProvidersList:  any = []

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  defaultFilter(): ManagementTemplatesFilter {
    return {
      tmpl: undefined,
      service_provider_name: undefined,
      mn_service_id: undefined,
      status_id: undefined,
    };
  }

  async created() {
    this.actionGetManagementServices();
    this.filtered();
    if (this.filter.service_provider_name) this.serviceProvidersList = await this.actionGetServiceProviders({name: this.filter.service_provider_name});
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Mail Notify template",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetManagementTemplates(this.filter);
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  getMNServiceName(id: number): string | undefined {
    return this.managementServicesList.find((e: any) => e.id === id)?.mn_service_name;
  }
}
